import React from "react";
import {Box} from "@mantine/core";
import {INoteStep} from "@/protocols/types/protocol.ts";
import {INoteStepDefinition} from "@/protocols/types/protocolDefinitions.ts";
import '@mdxeditor/editor/style.css'
import {MarkdownEditor} from "@/common/components/MarkdownEditor";
import {DeepPartial} from "@/utils/types/DeepPartial";
import {TWorkflow} from "../StepView";

/** Union type for Note steps (both execution and planning modes) */
type NoteStep = INoteStep | INoteStepDefinition;

export interface NoteStepViewProps {
    step: NoteStep;
    onChange: (updates: DeepPartial<NoteStep>) => void;
    workflow?: TWorkflow;
}

/**
 * View component for note steps.
 * This is the primary rendering for note steps in all contexts.
 * Used in protocol execution, planning, and review modes.
 */
export const NoteStepView: React.FC<NoteStepViewProps> = ({
    step,
    onChange,
    workflow = "session",
}) => {
    const handleNoteChange = (value: string) => {
        onChange({
            note: value
        });
    };

    return (
        <Box style={{display: "grid", grid: "auto / 1fr", gridColumn: "1 / -1", justifySelf: "center"}}>
            <MarkdownEditor title={"Notes"}
                            editingMode={workflow === "planning" || workflow === "review_edit"
                                ? "full"
                                : workflow === "session"
                                    ? "checkboxes"
                                    : "none"}
                            markdown={step.note || ""}
                            onChange={handleNoteChange}
                            mdDataTestId="input-note"
            />
        </Box>
    );
};